window.contributionFormatter = function(value, row) {
    let html = '';
    if (row.contribution_without_discount !== row.contribution_with_discount) {
        html += '<span class="text-decoration-line-through text-muted">';
        html += '&euro;';
        html += ' ';
        html += row.contribution_without_discount;
        html += '</span>';
        html += ' ';
        html += '&euro;';
        html += ' ';
        html += row.contribution_with_discount;
    } else {
        html += '&euro;';
        html += ' ';
        html += row.contribution_without_discount;
    }
    return html;
}
